export default {
  Emoji: {
    Reacted: 'reacted',
    You: 'You',
    PlusNOthers: 'plus %(n)i other',
  },
  ToolBar: {
    Emoji: 'Emoji',
    Reply: 'Reply',
    Copy: 'Copy',
    Edit: 'Edit',
    Delete: 'Delete',
  },
};
